import { toast } from '@/components/toasts/toast.helpers'

import { fetchingAPI, apiService } from '../../api'
import { setLoading, setMessageThread } from './messages.redux'

export const fetchMessageThread = (messageId) => async (dispatch) => {
  dispatch(setLoading({ messageThread: true }))

  try {
    const messageThread = await fetchingAPI(
      `${apiService.messageIngestion}/email-ingestion/thread/id/${messageId}`,
      'GET',
      dispatch
    )

    const sortedMessageThread = messageThread.sort(
      (a, b) => new Date(a.sent_at) - new Date(b.sent_at)
    )

    dispatch(setMessageThread(sortedMessageThread))
  } catch (err) {
    toast.error('Failed to fetch message thread', { cause: err })
  } finally {
    dispatch(setLoading({ messageThread: false }))
  }
}
